<template>
  <div class="page-container">
    <div class="page-title-container">
      <h1 class="page-title">
        {{ editing ? "Editar vehículo" : "Nuevo vehículo" }}
      </h1>
    </div>
    <div>
      <form class="custom-form" @submit.prevent="save" novalidate>
        <b-card
          tag="article"
          no-body
          style="max-width: 760px"
          class="custom-card"
        >
          <b-card-header
            header-tag="section"
            class="custom-card-header d-flex align-items-center"
          >
            <h3>
              {{ editing ? "Datos del usuario" : "Datos del nuevo usuario" }}
            </h3>
          </b-card-header>
          <b-card-body class="custom-card-body p-0">
            <section class="form-section">
              <div>
                <h2 class="form-subtitle">Información general</h2>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="license_plate">Placa *</label>
                    <input
                      id="license_plate"
                      type="text"
                      v-model="form.license_plate"
                      autocomplete="off"
                      placeholder="Ingresar placa (ej: ABC-123)"
                      maxlength="8"
                      :disabled="editing"
                      class="custom-form-control"
                      :class="{
                        'custom-form-control-error':
                          $v.form.license_plate.$error,
                      }"
                      @keypress="(e) => { if (!/[A-Za-z0-9-]/.test(e.key)) e.preventDefault() }"
                    />
                    <FormError
                      v-if="
                        $v.form.license_plate.$error &&
                        !$v.form.license_plate.required
                      "
                      message="Placa es requerida"
                    />
                    <FormError
                      v-if="$v.form.license_plate.$error && !$v.form.license_plate.validFormat"
                      message="Formato de placa inválido (ej: ABC-123)"
                    />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group mb-0">
                    <label for="brand">Marca *</label>

                    <FormSelect
                      id="brand"
                      :items="brandList"
                      v-model="form.brand"
                      defaultOption="Elegir marca"
                      :showError="$v.form.brand.$error && !$v.form.brand.required"
                    />

                    <FormError
                      v-if="$v.form.brand.$error && !$v.form.brand.required"
                      message="Marca es requerida"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="model">Modelo *</label>
                    <input
                      id="model"
                      type="text"
                      v-model="form.model"
                      autocomplete="off"
                      placeholder="Ingresar modelo"
                      class="custom-form-control"
                      :class="{
                        'custom-form-control-error': $v.form.model.$error,
                      }"
                    />
                    <FormError
                      v-if="$v.form.model.$error && !$v.form.model.required"
                      message="Modelo es requerido"
                    />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group mb-0">
                    <label for="profile">Tipo de vehículo *</label>
                    <FormSelect
                      id="vehicle_type_id"
                      :items="vehicleTypesList"
                      v-model="form.vehicle_type_id"
                      defaultOption="Elegir tipo de vehículo"
                      :showError="$v.form.vehicle_type_id.$error"
                    />

                    <FormError
                      v-if="
                        $v.form.vehicle_type_id.$error &&
                        !$v.form.vehicle_type_id.required
                      "
                      message="Vehículo es requerido"
                    />
                  </div>
                </div>

                <!-- <div class="col-md-6">
                  <div class="form-group mb-0">
                    <label for="capacity">Capacidad *</label>
                    <input
                      id="capacity"
                      type="number"
                      v-model="form.capacity"
                      autocomplete="off"
                      placeholder="Ingresar capacidad"
                      class="custom-form-control"
                      :class="{
                        'custom-form-control-error': $v.form.capacity.$error,
                      }"
                    />
                    <FormError
                      v-if="
                        $v.form.capacity.$error && !$v.form.capacity.required
                      "
                      message="Capacidad es requerida"
                    />
                    <FormError
                      v-if="
                        $v.form.capacity.$error && !$v.form.capacity.numeric
                      "
                      message="Capacidad debe ser un número"
                    />
                  </div>
                </div> -->

                <div class="col-md-6">
                  <div class="form-group mb-0">
                    <label for="ownership_type">Propiedad *</label>
                    <FormSelect
                      id="ownership_type"
                      :items="propertyList"
                      v-model="form.ownership_type"
                      defaultOption="Elegir tipo de propiedad"
                      :showError="$v.form.ownership_type.$error"
                    />
                    <FormError
                      v-if="
                        $v.form.ownership_type.$error && !$v.form.ownership_type.required
                      "
                      message="Propiedad es requerida"
                    />
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="form-group-buttons text-right">
                    <router-link
                      :to="{ name: 'config-vehicle-list' }"
                      class="button button-light"
                    >
                      {{ editing ? "Volver" : "Cancelar" }}
                    </router-link>
                    <button class="button button-primary" type="submit">
                      Guardar
                    </button>
                  </div>
                </div>
              </div>
            </section>
          </b-card-body>
        </b-card>
      </form>
    </div>
  </div>
</template>

<script>
import { Alert, FormSelect, FormError, Constants } from "wize-admin";

import { VehicleService, VehicleTypeService } from "@/core/services";
import { Constants as LocalConstants } from "@/core/utils";
import { required } from "vuelidate/lib/validators";

export default {
  components: {
    FormError,
    FormSelect,
  },
  data() {
    return {
      profileTypes: [
        LocalConstants.ProfileTypes.ADMIN,
        LocalConstants.ProfileTypes.SUPERVISOR,
      ],
      identifierTypes: [
        Constants.IdentifierType.DNI,
        Constants.IdentifierType.RUC,
        Constants.IdentifierType.CE,
        Constants.IdentifierType.PASAPORTE,
      ],
      brandList: LocalConstants.VehicleBrands,
      vehicleTypesList: [],
      propertyList: [
        LocalConstants.VehicleProperty.TRAVELCAB,
        LocalConstants.VehicleProperty.EXTERNAL,
      ],
      form: {
        model: null,
        license_plate: null,
        brand: null,
        vehicle_type_id: null,
        // capacity: null,
        ownership_type: null
      },
      editing: false,
    };
  },
  validations: {
    form: {
      model: { required },
      license_plate: {
        required,
        validFormat(value) {
          if (!value) return true
          return /^[A-Z0-9]{3}-\d{3}$/.test(value)
        }
      },
      brand: { required },
      vehicle_type_id: { required },
      // capacity: { required, numeric },
      ownership_type: { required }
    },
  },
  watch: {
    "$route.params.id": function () {
      if (this.$route.params.id) this.load(this.$route.params.id);
    },
    "form.license_plate"(val) {
      if (val && !this.editing) this.form.license_plate = val.toUpperCase()
    },
  },
  computed: {},
  methods: {
    async getVehicleTypes() {
      const vehicleTypes = (await VehicleTypeService.list({ status: 1 })).payload.items;
      vehicleTypes.forEach((vt) => this.vehicleTypesList.push({ key: vt.id, label: vt.name }));
    },
    async save() {
      this.$v.$touch();
      if (this.$v.$error) {
        this.$nextTick(() => {
          this.$smoothScroll({
            scrollTo: document.querySelector(".form-error"),
            updateHistory: false,
            offset: -50,
          });
        });

        return;
      }

      try {
        this.$store.dispatch("app/loading", true);

        const data = {
          ...this.form,
          brand: String(this.form.brand),
          // capacity: parseInt(this.form.capacity),
          ownership_type: String(this.form.ownership_type),
        };

        if (!this.editing) {
          await VehicleService.save(data);

          this.$router.push({
            name: "config-vehicle-list",
          });
        } else {
          await VehicleService.update(this.$route.params.id, data);
          this.load(this.$route.params.id);
        }

        Alert.success("Se almacenó la información correctamente");
      } catch (ex) {
        console.error(ex);
        Alert.error(ex.errors.message);
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },
    async load(id) {
      try {
        this.$store.dispatch("app/loading", true);
        const response = await VehicleService.get(id);
        const payload = response.payload;

        this.form = {
          ...payload,
        };

        // Si el tipo de vehículo asignado no está en la lista (ej: está inactivo),
        // se agrega para que FormSelect pueda mostrar el valor actual sin limpiarlo.
        const inList = this.vehicleTypesList.find(vt => vt.key == payload.vehicle_type_id);
        if (!inList) {
          const vtResponse = await VehicleTypeService.get(payload.vehicle_type_id);
          if (vtResponse && vtResponse.payload) {
            this.vehicleTypesList.push({ key: vtResponse.payload.id, label: vtResponse.payload.name });
          }
        }

        this.editing = true;
      } catch (e) {
        console.error(e);
        Alert.error(e.errors.message);
        this.$router.push({ name: "form-list" });
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },
  },
  async created() {
    await this.getVehicleTypes()
    if (this.$route.params.id) this.load(this.$route.params.id);
  },
};
</script>

<style lang="stylus" scoped></style>
